import React, { useEffect, useState } from "react";

//=== Packages == //

import Image from "next/image";

//=== Images == //
import product from "../media/Session-img.png";

//=== Components == //

import SideDrawer from "../compononents/SideDrawer/SideDrawer";
import Payment from "../forms/Payment";
import PaymentPlan from "./PaymentPlan";
import ShoppingCartListing from "../compononents/ShoppingCartListing/ShoppingCartListing";
import OrderSummary from "./OrderSummary";
import CoursesQuantity from "./CoursesQuantity";
import { CURRENCY_SIGNS, getUserData } from "../../../hooks/HelperFunctions";
import { useShoppingCart } from "../../../contexts/CartContext";

import { usePathname } from "next/navigation";
import { useSelector } from "react-redux";

export default function ShoppingCart({ setOpenSignUpModel }) {

  const activeCurrency = useSelector(
    (state) => state.currency.activeCurrency
  );
  
  const [paymentData, setPaymentData] = useState({
    userId: "",
    courseIdsCheckout: "",
    tracksAndTerms: [],
  });
  const [courses, setCourses] = useState([]);
  const [shoppingData, setShoppingData] = useState([]);
  const { cartItems, setCartItems, cartItemsCoupons, setCartItemsCoupons } = useShoppingCart();
  const [totalPriceToShow, setTotalPriceToShow] = useState(0);
  const [seletedCartItemId, setSeletedCartItemId] = useState({});
  const [removeTrackFromCartItemId, setRemoveTrackFromCartItemId] =
    useState("");
  const [removeCourseFromCartItemId, setRemoveCourseFromCartItemId] =
    useState("");

  // ===================================== Payment Drawer Start ===============================//
  const API_URL =
    process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
      ? process.env.NEXT_PUBLIC_API_URL_PROD
      : process.env.NEXT_PUBLIC_API_URL_DEV;
  const baseUrl = typeof window !== "undefined" ? window.location.origin : "";
  const getOnlyCourses = cartItems?.filter((course) => course?.courseId);
  const [courseIds, setCourseIds] = useState(() => {
    return cartItems
      ? Object.keys(getOnlyCourses)
          .map(function (k) {
            return getOnlyCourses[k]["courseId"];
          })
          .join("-")
      : "";
  });

  const pathname = usePathname();
  const [openPaymentDrawer, setOpenPaymentDrawer] = useState(false);
  const handleOpenPaymentDrawer = () => {
    if (cartItems?.length === 0) {
      return;
    }
    const empty = [];
    const userAuthenticated = localStorage.getItem("userAuthenticated");
    if (userAuthenticated == "true") {
      const userData = getUserData();
      const userId = userData.id;
      const trackPriceId = localStorage.getItem("trackPriceId");
      const sendingTrackId = localStorage.getItem("trackId");
      const courseIdsCheckout = courseIds.length > 0 ? courseIds : "";
      const tracksAndTermsData = cartItems.map((term) => ({
        trackId: term?.trackId,
        terms: [
          {
            termId: term?.id || "",
            courseIds: term?.courses?.map((course) => course.courseId) || "",
          },
        ],
      }));

      const tracksAndTerms = tracksAndTermsData?.filter(
        (items) => items?.trackId !== undefined
      );
      const encodedTermsAndCourses = encodeURIComponent(
        JSON.stringify(tracksAndTerms)
      );
      setPaymentData({
        ...paymentData,
        userId: userId,
        courseIdsCheckout: courseIdsCheckout,
        tracksAndTerms: tracksAndTerms,
      });

      const checkoutBackEndUrl = `${API_URL}/checkoutTracksAndIndependentCourses?userId=${userId}&independentCourseIds=${courseIdsCheckout}&tracksAndTerms=${
        tracksAndTerms?.length > 0 ? encodedTermsAndCourses : ""
      }&frontEndUrl=${
        pathname === "/shopping"
          ? `${baseUrl.replace(/\/shopping$/, "")}`
          : baseUrl
      }`;

      setOpenPaymentDrawer(true);
      return false;

      window.location.replace(checkoutBackEndUrl);
    } else {
      // localStorage.setItem("cartPaymentInfo", JSON.stringify(empty));
      setOpenSignUpModel(true);
    }
  };
  const ClosePaymentDrawer = () => {
    // setOpenSignUpModel(true);
    setOpenPaymentDrawer(false);
  };
  // ====================================== Payment Drawer End ==============================//

  // ====== Payment Plan Drawer Start======//
  const [openPlanDrawer, setOpenPlanDrawer] = useState(false);
  const handleOpenPlanDrawer = () => {
    setOpenPlanDrawer(true);
  };
  const ClosePlanDrawer = () => {
    setOpenPlanDrawer(false);
  };
  // ====== Payment Plan Drawer End======//
  //================================= handleRemove data ==================================//
  const handleRemove = (trackId, courseID) => {
    setRemoveTrackFromCartItemId(trackId);
    setRemoveCourseFromCartItemId(courseID);
  };
  //================================= handleRemove data ==================================//

  //============================== setting data ===========================================//

  useEffect(() => {
    let empty = [];
    if (cartItems?.length > 0) {
      setShoppingData(showData(cartItems));
    } else {
      setShoppingData(showData(empty));
    }
  }, [cartItems, cartItemsCoupons]);
  //============================== setting data ===========================================//
  //============================== remove data ===========================================//
  useEffect(() => {
    if (removeTrackFromCartItemId) {
      let latestCartItem = cartItems?.filter(
        (cartItem) => cartItem?.id !== parseInt(removeTrackFromCartItemId)
      );
      // setTacksToShopping(latestCartItem);
      setCartItems(latestCartItem);
      localStorage.setItem("cartPaymentInfo", JSON.stringify(latestCartItem));
    }
  }, [removeTrackFromCartItemId]);
  useEffect(() => {
    if (removeCourseFromCartItemId) {
      let latestCartItem = cartItems?.filter(
        (cartItem) =>
          cartItem?.courseId !== parseInt(removeCourseFromCartItemId)
      );

      let latestCartItemCoupons = cartItemsCoupons?.filter((singleItem) => singleItem?.courseId !==  parseInt(removeCourseFromCartItemId))
      // setTacksToShopping(latestCartItem);
      const getOnlyCourses = latestCartItem?.filter(
        (course) => course?.courseId
      );
      setCartItems(latestCartItem);
      setCartItemsCoupons(latestCartItemCoupons)
      localStorage.setItem("cartPaymentInfo", JSON.stringify(latestCartItem));
      localStorage.setItem("selectedCourses", JSON.stringify(getOnlyCourses));
      localStorage.setItem("itemsCoupons", JSON.stringify(latestCartItemCoupons));
    }
  }, [removeCourseFromCartItemId]);
  //============================== remove data ===========================================//
  //================================= get toatl price ======================================//

  const totalData = (courseData) => {
    let totalPrice = courseData?.reduce((total, data) => {
      if (
        data &&
        data.trackTermCoursesTotalPrice !== null &&
        data.trackTermCoursesTotalPrice !== undefined
      ) {
        let singleTrackCoursesSelectedPrice = 0;
        data?.courses?.map((course) => {
          singleTrackCoursesSelectedPrice +=
            course?.course?.price && course.course.priceCat !== "Free"
              ? parseFloat(course?.course?.price)
              : 0;
        });
        total += parseFloat(singleTrackCoursesSelectedPrice);
      } else if (data && data.price !== null && data.price !== undefined) {
        let foundCourse = cartItemsCoupons?.find(singleCourse => singleCourse?.courseId == data?.courseId)

        total += parseFloat(calculatePrice(foundCourse,data,data?.price));
      }

      return total;
    }, 0);
    return totalPrice || 0;
  };

  //================================= get toatl price ======================================//

  //================================= listing data =========================================//

  let calculatePrice = (courseWithCoupons, item, itemPrice) => {
    let itemPriceTemp = parseFloat(itemPrice);
    
    courseWithCoupons?.couponIds?.forEach((couponId) => {
      let itemPriceTemp2 = parseFloat(itemPrice);
      let foundCourse = cartItems?.find((course) => course?.courseId == item?.courseId)
      let couponInfo = foundCourse?.active_coupons?.find(singleCoupon => singleCoupon?.id == couponId);


      if(!couponInfo){
        let triedCoupons = localStorage.getItem("tried_coupons") ? JSON.parse(localStorage.getItem("tried_coupons")) : []
        couponInfo = triedCoupons.find((singleCoupon) => singleCoupon?.id == couponId)
      }

  
      if (couponInfo) {
        const discountType = couponInfo?.discount_type;
        const discountValue = parseFloat(couponInfo?.discount_value);
  
        let discountAmount = 0;
  
        if (discountType === 'fixed') {
          const baseUsd = foundCourse?.base_usd_price;
          const currency = foundCourse?.currency
          const current_currency_price = foundCourse?.price;
          const rate = current_currency_price/baseUsd;

          const fixedCouponUsd = couponInfo?.discount_value;

          let discountedCurrentCurrencyAmount = Number((fixedCouponUsd * rate).toFixed(2));
          discountedCurrentCurrencyAmount = (currency == "USD") ? parseInt(discountedCurrentCurrencyAmount) : discountedCurrentCurrencyAmount

          discountAmount = discountedCurrentCurrencyAmount;

          // discountAmount = discountValue;
        } else if (discountType === 'percentage') {
          discountAmount = (discountValue / 100) * itemPriceTemp2;
        }
  
        itemPriceTemp -= discountAmount;
        // Prevent negative prices
        if (itemPriceTemp < 0) itemPriceTemp = 0;
      }
    });
  
    return itemPriceTemp.toFixed(2);
  };
  

  const showData = (arr) => {
    if (arr?.length > 0) {
      return arr?.map((item) => {
        let foundCourse = cartItemsCoupons?.find(singleCourse => singleCourse?.courseId == item?.courseId)
        
        let priceToShow = "";

        if (item?.courseTitle) {
          priceToShow = `${getTheCorrectCurrencySign()}${
            item?.price && item?.priceCat !== "Free"
              ? parseFloat(calculatePrice(foundCourse,item,item?.price))?.toFixed(2)
              : "0.00"
          }`;
        } else {
          let trackPriceBasedOnCourse = 0;
          item?.courses?.map((course) => {
            trackPriceBasedOnCourse +=
              course.course.priceCat !== "Free"
                ? parseFloat(course?.course?.price)
                : 0;
          });
          priceToShow = `${getTheCorrectCurrencySign()}${
            trackPriceBasedOnCourse
              ? parseFloat(trackPriceBasedOnCourse)?.toFixed(2)
              : "0.00"
          }`;

          
        }
        
        return {
          courseId : item?.courseId,
          Img: item.trackImage ? item.trackImage : item?.courseImage,
          Title: item?.courseTitle
            ? item?.courseTitle
            : `${item.name} : ${item.trackTermName}`,
          Description: "",
          organizationName: item?.orgName,
          SelectedCoursesQuantity: item?.courseTitle ? false : true,
          SelectedCoursesQuantityLabel: !item?.courseTitle
            ? ` 
          ${
            item?.courses?.length > 1
              ? `${item?.courses?.length} Courses`
              : `${item?.courses?.length} Course`
          }`
            : "",
          handleOpenCoursesQuantity: (e) =>
            handleOpenCoursesQuantityDrawer(item),
          NewPrice: priceToShow,
          OldPrice: (calculatePrice(foundCourse,item,item?.price) != item?.price) ? `${getTheCorrectCurrencySign()}${item?.price}` : "",
          Remove: true,
          onClickRemove: (e) => handleRemove(item?.id, item?.courseId),
          AddProductCoupon: item?.courseTitle ? "Add course coupon " : false,
          // handleOpenAddProductCoupon:handleOpenAddProductCoupon

          Save: (foundCourse && foundCourse?.couponIds?.length > 0),
          couponFound : (foundCourse && foundCourse?.couponIds?.length > 0) ? foundCourse?.couponIds : [],
          SaveLabel:"SAVE10 (10% off)",
  
        
        };
      });
    } else {
      return [];
    }
  };
  //================================= listing data =========================================//

  {
    /* === Selected Courses Quantity Details Drawer=== */
  }
  const [CoursesQuantityDrawer, setOpenCoursesQuantityDrawer] = useState(false);
  const handleOpenCoursesQuantityDrawer = (item) => {
    setSeletedCartItemId(item);
    setOpenCoursesQuantityDrawer(true);
  };
  const ClosePlanCoursesQuantityDrawer = () => {
    setOpenCoursesQuantityDrawer(false);
  };
  {
    /* === Selected Courses Quantity Details Drawer=== */
  }

  // const shoppingData = [
  //   {
  //     Img: product,
  //     Title:
  //       "On The Timing and Virtues of the Night of Power: The Heart's Joy in Remembering Laylat al-Qadr",
  //     Description: "Hikmah Academy of California",
  //     SelectedCoursesQuantity: true,
  //     SelectedCoursesQuantityLabel: "2 courses",
  //     handleOpenCoursesQuantity: handleOpenCoursesQuantityDrawer,
  //     OldPrice: "$4000",
  //     NewPrice: "$3600",
  //     Remove: true,
  //     //onClickRemove:onClickRemove,
  //   },

  //   {
  //     Img: product,
  //     Title:
  //       "On The Timing and Virtues of the Night of Power: The Heart's Joy in Remembering Laylat al-Qadr",
  //     Description: "Hikmah Academy of California",
  //     OldPrice: "$4000",
  //     NewPrice: "$3600",
  //     Remove: true,
  //     //onClickRemove:onClickRemove,
  //   },

  //   {
  //     Img: product,
  //     Title:
  //       "On The Timing and Virtues of the Night of Power: The Heart's Joy in Remembering Laylat al-Qadr",
  //     Description: "Hikmah Academy of California",
  //     OldPrice: "$4000",
  //     NewPrice: "$3600",
  //     Remove: true,
  //     //onClickRemove:onClickRemove,
  //   },
  // ];

  useEffect(() => {
    if (cartItems?.length > 0) {
      let coursesArray = [];
      cartItems?.map((singleCourseTrack) => {
        if (singleCourseTrack?.track_id && singleCourseTrack?.track_id > 0) {
          singleCourseTrack?.courses?.map((singleCourse) => {
            coursesArray.push(singleCourse?.course);
          });
        } else {
          coursesArray.push(singleCourseTrack);
        }
      });
      setCourses(coursesArray);
    }
  }, [cartItems]);

  useEffect(() => {
    let coursesArrayNew = [];
    let totalPrice = 0;
    courses?.map((singleCourse) => {
      coursesArrayNew.push({
        img: singleCourse?.courseImage,
        title: singleCourse?.courseTitle,
        price: singleCourse?.price,
      });
      if (
        singleCourse?.price &&
        singleCourse?.price > 0 &&
        singleCourse.priceCat !== "Free"
      ) {
        let foundCourse = cartItemsCoupons?.find(course => course?.courseId == singleCourse?.courseId)

        totalPrice += parseFloat(calculatePrice(foundCourse,singleCourse,singleCourse?.price));
      }
    });
    setTotalPriceToShow(totalPrice);
    // setShoppingData(coursesArrayNew);
  }, [courses, cartItemsCoupons]);


  const getTheCorrectCurrencySign = () => {
    return CURRENCY_SIGNS[activeCurrency] ?? "$";
  };

  return (
    <>
      <div className="PM_ShoppingCartContainer">
        <ShoppingCartListing
          shoppingData={shoppingData}
          CurrencySign={getTheCorrectCurrencySign()}
          // SubTotal={false}
          // Subtotal="4009.99"
          Total={parseFloat(totalData(cartItems))?.toFixed(2)}
          // EnterProductCouponCodeValue="SAVE20"
          //onClickProductCouponApply={onClickProductCouponApply}

          // AddPlatformCoupon={false}
          // AddPlatformCouponLabel="Add Takbir coupon"
          OfferChip={true}
          OfferLabel="SAVE10 (10% off)"
          //onClickPlatformCouponApply={onClickPlatformCouponApply}

          //onClickRemoveCoupon={onClickRemoveCoupon}
          TotalSection={true}
          CheckboutButton={totalData(cartItems) === 0 ? false : true}
          onClickCheckout={handleOpenPaymentDrawer}
          ContinueBrowsingSection={true}
          BrowsingLink="/"
          EmptyCard={false}
  
        />
      </div>

      {/* === Payment Drawer Start*/}
      <SideDrawer
        drawerWidth="744px"
        padding="24px"
        title="Checkout"
        sideOpen="right"
        open={openPaymentDrawer}
        handleDrawerClose={ClosePaymentDrawer}
        Headerbackground="#004FE0"
        HeaderTextColor="#fff"
        DrawerWidth="870px"
        SubDrawer="SubDrawer"
        body={
          <Payment
            courses={courses}
            cartItems={cartItems}
            paymentData={paymentData}
            totalPriceToShow={totalPriceToShow}
            setOpenPaymentDrawer={setOpenPaymentDrawer}
          />
        }
        SubDrawerbody={
          <OrderSummary
            courses={courses}
            cartItems={cartItems}
            paymentData={paymentData}
            shoppingData={shoppingData}
            totalPriceToShow={totalPriceToShow}
            setOpenPaymentDrawer={setOpenPaymentDrawer}
          />
        }
      />
      {/* === Payment Drawer End*/}

      {/* === Payment Plan Start === */}
      <SideDrawer
        drawerWidth="744px"
        padding="24px"
        title="Select Payment Plan"
        sideOpen="right"
        open={openPlanDrawer}
        handleDrawerClose={ClosePlanDrawer}
        Headerbackground="#0B9444"
        HeaderTextColor="#fff"
        body={<PaymentPlan />}
      />
      {/* === Payment Plan End === */}

      {/* === Selected Courses Quantity Details Drawer=== */}
      <SideDrawer
        drawerWidth="744px"
        padding="24px"
        BackLabel="Back to cart"
        BackArrow={true}
        sideOpen="right"
        open={CoursesQuantityDrawer}
        handleDrawerClose={ClosePlanCoursesQuantityDrawer}
        Headerbackground="#fff"
        HeaderTextColor="#004FE0"
        cursor="pointer"
        body={
          <CoursesQuantity
            seletedCartItemId={seletedCartItemId}
            setOpenCoursesQuantityDrawer={setOpenCoursesQuantityDrawer}
            setCartItems={setCartItems}
            cartItems={cartItems}
            setOpenSignUpModel={setOpenSignUpModel}
          />
        }
      />
      {/* === Payment Plan End === */}
    </>
  );
}
